module.exports = __webpack_public_path__ + "assets/media/guillaume_face.45410bf5.jpg";